import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import { PostCard } from 'features/Blog/components/PostCard'
import { mapVariantsToIndex } from 'features/Blog/screens/PostsList/PostsList'
import { BlogPostItemFields, BlogPostMetadata } from '../../Post'
import { DottedLine, RelatedPostsGrid, RelatedPostsRoot } from './RelatedPosts.styles'

type RelatedPostsProps = {
  relatedPosts: { fields: BlogPostItemFields; metadata: BlogPostMetadata }[]
}

export const RelatedPosts = ({ relatedPosts }: RelatedPostsProps) => {
  return (
    <RelatedPostsRoot>
      <Stack direction="column" gap="3">
        <Stack direction="column" gap="2" alignItems="center">
          <Text as="h2" size="h2" weight="semiBold" align="center" display="block">
            More from THE RAW REPORT
          </Text>

          <DottedLine />
        </Stack>

        <RelatedPostsGrid>
          {relatedPosts.map((post, index) => {
            return (
              <PostCard
                key={post.fields.postUrl}
                post={post}
                variant={mapVariantsToIndex[index % 4]}
                masonry={false}
              />
            )
          })}
        </RelatedPostsGrid>
      </Stack>
    </RelatedPostsRoot>
  )
}
